import { DetailedInsight } from '@api/api/insights';
import { KgInsight } from '@api/api/kg-insights';
import { SentimentSummaryCard } from '@terminal/components/sentiment-summary-card/SentimentSummaryCard';
import { useInsightsById } from '@terminal/react-query-hooks/insights/useInsight';
import { useKgInsightsById } from '@terminal/react-query-hooks/insights/useKgInsight';
import {
  POSTHOG_TRACKING_SOURCES,
  PosthogTrackingSource,
} from '@terminal/services/tracking/posthog/constants';
import {
  PulseMonthlySummaries,
  PulseSentimentDirection,
} from '@terminal/views/theme-overview/tab-content/pulse-overview/pulse-types';
import { citationIdsByTypeForDirection } from '@terminal/views/theme-overview/tab-content/pulse-overview/utils/citationIdsForDirection';
import styles from './MonthlySentimentCards.module.scss';

export const MonthlySentimentCards = ({
  summaries,
  themeId,
  source = POSTHOG_TRACKING_SOURCES.THEME_OVERVIEW,
  onOpenDrawer,
}: {
  summaries: PulseMonthlySummaries;
  themeId?: string;
  source?: PosthogTrackingSource;
  onOpenDrawer: (direction: PulseSentimentDirection) => void;
}) => {
  const { kgInsightIds, scenarioInsightIds } = citationIdsByTypeForDirection(
    summaries,
    'all'
  );

  const kgInsightsById = useKgInsightsById(kgInsightIds);
  const scenarioInsightsById = useInsightsById(scenarioInsightIds);
  const insightsById = new Map<string, KgInsight | DetailedInsight>([
    ...kgInsightsById,
    ...scenarioInsightsById,
  ]);
  const scenarioInsightIdSet = new Set(scenarioInsightIds);

  return (
    <div className={styles.root}>
      <SentimentSummaryCard
        direction="tailwind"
        summary={summaries.tailwind}
        themeId={themeId}
        insightsById={insightsById}
        scenarioInsightIds={scenarioInsightIdSet}
        source={source}
        onOpen={() => onOpenDrawer('tailwind')}
      />
      <SentimentSummaryCard
        direction="headwind"
        summary={summaries.headwind}
        themeId={themeId}
        insightsById={insightsById}
        scenarioInsightIds={scenarioInsightIdSet}
        source={source}
        onOpen={() => onOpenDrawer('headwind')}
      />
    </div>
  );
};
